import React, { CSSProperties, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import ErrorFallback from "../ErrorFallback";
import SkeletonLoading from "../SkeletonLoading";

interface AsyncContainerProps {
  children: JSX.Element | JSX.Element[];
  suspenseFallback?: JSX.Element;
  style?: CSSProperties;
}

/* 
TODO: 추후 width와 height을 받아서 suspenseFallback이 입력되지 않으면 기본 spinner를 표시
ErrorFallback도 width, height이 들어가는 컴포넌트로 변경해서 
다양한 상황에 재사용이 가능하도록 변경
*/
const AsyncContainer = ({
  children,
  style,
  suspenseFallback = <SkeletonLoading style={style} />,
}: AsyncContainerProps) => {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary, error }) => (
            <ErrorFallback
              resetBoundary={() => resetErrorBoundary()}
              error={error}
              style={style}
            />
          )}
        >
          <Suspense fallback={suspenseFallback}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};

export default AsyncContainer;
